import script from "./Actions.vue?vue&type=script&lang=ts&setup=true"
export * from "./Actions.vue?vue&type=script&lang=ts&setup=true"

export default script